var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeadLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 103,
    viewBox: "0 0 236 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.6161 0.0999756H0.911133V19.504H28.5471V103H48.8331V19.504H76.6161V0.0999756Z",
    fill: "#38D68B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M235.85 0.0999756H214.976L185.576 48.757L156.029 0.0999756H135.155V103H155.441V36.409L184.4 84.037H186.752L215.711 36.262V103H235.85V0.0999756Z",
    fill: "#38D68B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.583 0.0999756C95.2246 0.0999756 90.8809 4.44371 90.8809 9.80198V9.80198C90.8809 15.1602 95.2246 19.504 100.583 19.504H103.465C108.823 19.504 113.167 15.1602 113.167 9.80198V9.80198C113.167 4.44371 108.823 0.0999756 103.465 0.0999756H100.583Z",
    fill: "#2EB675"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8809 23.1519V32.5559H113.167V23.1519H90.8809Z",
    fill: "#2EB675"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8809 35.1V44.504H113.167V35.1H90.8809Z",
    fill: "#2EB675"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8809 47.1V56.504H113.167V47.1H90.8809Z",
    fill: "#2EB675"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8809 58.9514V103H113.167V58.9514H90.8809Z",
    fill: "#2EB675"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadLogo);
export default __webpack_public_path__ + "static/media/headLogo.f3e99a86f284673cb002b192bc935f85.svg";
export { ForwardRef as ReactComponent };